import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";
import { Lightning } from "@phosphor-icons/react";

export default function Register() {
  const [form, setForm] = useState({ name: "", email: "", password: "" });
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const { register } = useAuth();
  const navigate = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    const res = await register(form);
    setLoading(false);
    if (res.ok) navigate("/dashboard");
    else setError(res.error);
  };

  const set = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  return (
    <div className="min-h-screen flex items-center justify-center p-6">
      <div className="w-full max-w-md">
        <div className="flex items-center gap-2 mb-10">
          <Lightning size={28} weight="fill" className="text-[#007AFF]" />
          <span className="font-heading font-black text-2xl tracking-tighter">PROJECT PULSE</span>
        </div>
        <h1 className="font-heading text-4xl sm:text-5xl font-black tracking-tighter leading-none mb-2">
          Deploy your<br/>team.
        </h1>
        <p className="text-[color:var(--text-secondary)] mt-4 mb-10">
          Set up your operator profile in seconds.
        </p>
        <form onSubmit={submit} className="space-y-4" data-testid="register-form">
          <div>
            <label className="label-mono block mb-2">Full name</label>
            <input data-testid="register-name-input" required className="input" value={form.name} onChange={set("name")} />
          </div>
          <div>
            <label className="label-mono block mb-2">Email</label>
            <input data-testid="register-email-input" type="email" required className="input" value={form.email} onChange={set("email")} />
          </div>
          <div>
            <label className="label-mono block mb-2">Password</label>
            <input data-testid="register-password-input" type="password" required minLength={6} className="input" value={form.password} onChange={set("password")} />
          </div>
          <p className="text-xs text-[color:var(--text-tertiary)]">
            You'll join as a Producer by default. A project admin can promote you or invite you into another role.
          </p>
          {error && (
            <div data-testid="register-error" className="text-sm text-red-400 border border-red-500/30 bg-red-500/10 rounded px-3 py-2">
              {error}
            </div>
          )}
          <button data-testid="register-submit-button" disabled={loading} className="btn-primary w-full justify-center">
            {loading ? "Creating..." : "Create account"}
          </button>
        </form>
        <p className="text-sm text-[color:var(--text-secondary)] mt-8">
          Already enlisted?{" "}
          <Link data-testid="goto-login-link" to="/login" className="text-[#007AFF] hover:underline font-semibold">
            Sign in
          </Link>
        </p>
      </div>
    </div>
  );
}
